module.exports = __webpack_public_path__ + "static/media/chat.66c1f0df.svg";